<style>
    .has-error .form-control {
        border-color: #a94442 !important;
    }
    .has-error .form-control::placeholder {
        color: #a94442 !important;
    }
</style>
<template>
    <div class="vbf">
        <h2 class="form_title"><i class="fa fa-calendar"></i> <span class="text-uppercase" v-lang.book></span></h2>
        <form id="booking-form" class="inner">
            <div :class="{'form-group col-md-6 col-sm-6 col-xs-12 nopadding': true, 'has-error': errors.has('firstName')}">
                <div class="input-group">
                    <input v-validate="'required'" class="form-control" name="firstName" :placeholder="tr('enter_name')" type="text" v-model="form.firstName">
                </div>
            </div>
            <div :class="{'form-group col-md-6 col-sm-6 col-xs-12 nopadding': true, 'has-error': errors.has('lastName')}">
                <div class="input-group">
                    <input v-validate="'required'" class="form-control" name="lastName" :placeholder="tr('enter_lastname')" type="text" v-model="form.lastName">
                </div>
            </div>
            <div :class="{'form-group': true, 'has-error': errors.has('email')}">
                <input v-validate="'required|email'" class="form-control" name="email" :placeholder="tr('enter_email')" type="email" v-model="form.email">
            </div>
            <div :class="{'form-group': true, 'has-error': errors.has('phone')}">
                <input v-validate="'required'" class="form-control" name="phone" :placeholder="tr('enter_phone')" type="tel" v-model="form.phone">
            </div>
            <div :class="{'form-group col-md-6 col-sm-6 col-xs-12 nopadding': true, 'has-error': errors.has('checkin')}">
                <div class="input-group">
                    <div class="form_date">
                        <input v-validate="'required|date_format:DD/MM/YYYY'" type="text" id="checkin-datepicker" class="datepicker form-control md_noborder_right" name="checkin" :placeholder="tr('arrival_date')" readonly>
                    </div>
                </div>
            </div>
            <div :class="{'form-group col-md-6 col-sm-6 col-xs-12 nopadding': true, 'has-error': errors.has('checkout')}">
                <div class="input-group">
                    <div class="form_date">
                        <input v-validate="'required|date_format:DD/MM/YYYY'" type="text" id="checkout-datepicker" class="datepicker form-control" name="checkout" :placeholder="tr('departure_date')" readonly>
                    </div>
                </div>
            </div>
            <div :class="{'form-group': true, 'has-error': errors.has('roomType')}">
                <div class="form_select">
                    <select v-validate="'required|numeric'" name="roomType" id="select_roomtypes" v-model="form.roomType" class="form-control" :title="tr('title_room_type')" :data-header="tr('room_type')" :disabled="availableRoomTypes.length <= 0">
                        <option v-for="roomType in availableRoomTypes" :key="`room_type_${roomType.id}`" :value="roomType.id">
                            {{roomType.name.es}} {{ getPrice(roomType) }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row" v-show="selectedRoomType" style="margin-bottom: 10px;">
                <div class="col-xs-6">
                    <span style="color:#585858;">Cap. estándar: {{selectedRoomType.minCap}} <i class="fa fa-user"></i></span>
                </div>
                <div class="col-xs-6">
                    <span style="color:#585858;">Cap. máxima: {{selectedRoomType.maxCap}} <i class="fa fa-user"></i></span>
                </div>
            </div>
            <div :class="{'form-group col-md-6 col-sm-6 col-xs-12 nopadding': true, 'has-error': errors.has('adults')}">
                <div class="form_select">
                    <select v-validate="'required|numeric'" id="select_adults" name="adults" class="form-control md_noborder_right" :title="tr('adults')" :data-header="tr('adults')" v-model="form.adults">
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                    </select>
                </div>
            </div>
            <div :class="{'form-group col-md-6 col-sm-6 col-xs-12 nopadding': true, 'has-error': errors.has('kids')}">
                <div class="form_select">
                    <select v-validate="'required|numeric'" id="select_kids" name="kids" class="form-control" :title="tr('children')" :data-header="tr('children')" v-model="form.kids">
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                    </select>
                </div>
            </div>
            <div class="form-group col-xs-12" v-show="subtotal !== 0">
                <p style="text-align: right;font-size: 0.8em;color: #585858;font-weight: 700;letter-spacing: 1px;margin: 0 0 5px;text-transform: uppercase;word-spacing: 1px;position: relative;padding-left: 35px;">
                    Hospedaje ({{nights}} noches): ${{ getNightsTotal(nights, selectedRoomType) }}
                </p>
                <p v-show="additionalPersons > 0" style="text-align: right;font-size: 0.8em;color: #585858;font-weight: 700;letter-spacing: 1px;margin: 5px 0;text-transform: uppercase;word-spacing: 1px;position: relative;padding-left: 35px;">
                    Persona adicional ({{additionalPersons}}): ${{ getAdditionalPersonsTotal(nights, selectedRoomType) }}
                </p>
                <p style="text-align: right;font-size: 1.2em;color: #585858;font-weight: 700;letter-spacing: 1px;margin: 5px 0 10px;text-transform: uppercase;word-spacing: 1px;position: relative;padding-left: 35px;">
                    Subtotal: ${{subtotal}}
                </p>
            </div>
            <button class="button btn_lg btn_blue btn_full" type="button" @click="send" v-lang.book_now></button>
            <div class="a_center mt10">
                <a class="a_b_f" v-lang.advanced_booking_form></a>
            </div>
        </form>
    </div>
</template>

<script>
    import moment from 'moment';
    import Vue from 'vue';
    import httpClient from '../../HttpRequest';

    require('moment-timezone');

    export default
    {
        data() {
            return {
                form: {
                    firstName: '',
                    lastName: '',
                    roomType: '',
                    checkin: '',
                    checkout: '',
                    email: '',
                    phone: '',
                    country: 0,
                    adults: '',
                    kids: '',
                },
                additionalPersons: 0,
                roomTypes: [],
                availables: {},
            };
        },
        mounted() {
            const self = this;
            const $selectores = $('#booking-form').find('select');
            $selectores.selectpicker({
                style: 'btn-select',
                size: 'auto',
                container: 'body',
            });
            $('#select_adults,#select_kids').on('changed.bs.select', (e, index, newVal, oldVal) => {
              self.checkRoomCap();
            });
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
                $selectores.selectpicker('mobile');
            }
            $('#checkin-datepicker').datepicker({
                format: 'dd/mm/yyyy',
                autoclose: true,
                startDate: moment().toDate(),
            }).on('changeDate', (e) => {
                this.form.checkin = moment.tz(`${moment(e.date).format('YYYY-MM-DD')} 00:00`, 'America/Merida').toDate();
                $('#checkout-datepicker').datepicker('setStartDate', moment(e.date).add(1, 'days').toDate());
            });
            $('#checkout-datepicker').datepicker({
                format: 'dd/mm/yyyy',
                autoclose: true,
                startDate: moment().add(1, 'days').toDate(),
            }).on('changeDate', (e) => {
                this.form.checkout = moment.tz(`${moment(e.date).format('YYYY-MM-DD')} 00:00`, 'America/Merida').toDate();
                this.checkAvailability();
            });
        },
        created() {
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                if(self.$store.getters.config !== null) {
                    self.roomTypes = self.$store.getters.config.rooms.items;
                }
            });
          /*this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
            self.rooms = self.$store.getters.config.rooms.items;
          });*/
        },
        beforeDestroy() {
          $('#booking-form').find('select').val('').selectpicker('destroy');
          $('#checkin-datepicker').datepicker('destroy');
          $('#checkout-datepicker').datepicker('destroy');
        },
        methods: {
            checkRoomCap() {
              const { adults, kids, roomType } = this.form;
              if (roomType) {
                const roomTypeObj = this.roomTypes.find(e => e.id === Number(roomType));
                if (roomTypeObj) {
                  const totalPersons = Number(adults) + Number(kids);
                  const isValid = totalPersons <= roomTypeObj.maxCap;
                  this.additionalPersons = 0;
                  if (!isValid) {
                    this.$swal(this.tr('modal_reservation_maxcap_exceed_title'), this.tr('modal_reservation_maxcap_exceed_body'), 'warning');
                  } else {
                    if (totalPersons > roomTypeObj.minCap) {
                      this.additionalPersons = totalPersons - roomTypeObj.minCap;
                    }
                  }
                  return isValid;
                }
              }
              return false;
            },
            getPrice(roomType) {
              if (roomType && roomType.price) {
                const nightString = this.tr('night');
                return `($${roomType.price} / ${nightString})`;
              }
              return '';
            },
            checkAvailability() {
              const { checkin, checkout } = this.form;
              const self = this;
              if (checkin && checkout && Number(moment(checkout).diff(moment(checkin), 'days')) > 0) {
                httpClient.get('/hotel-availability', {
                  params: {
                    start: moment(checkin).format('YYYY-MM-DD'),
                    end: moment(checkout).format('YYYY-MM-DD'),
                  },
                }).then((resp) => {
                    this.availables = resp.data;
                    setTimeout(() => {
                      console.log('refreshing select roomtypes');
                      $('#select_roomtypes').selectpicker('refresh');
                    }, 200);
                }).catch((err) => {
                  alert('Ocurrió un error al conectar con el servidor.')
                });
              } else {
                alert('Debe seleccionar un rango de fechas válido');
              }
            },
            tr : function(t){
                return this.translate( this.$language, t);
            },
            send() {
              console.log(this.form);
              const { tr } = this;
              this.$validator.validateAll().then((result) => {
                if (result) {
                  if (this.checkRoomCap()) {
                      this.$swal({
                        title: tr('modal_confirm_reservation_title'),
                        text: tr('modal_confirm_reservation_body'),
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: tr('modal_confirm_reservation_confirmButtonText'),
                        cancelButtonText: tr('modal_confirm_reservation_cancelButtonText'),
                      }).then(() => {
                        const {
                          firstName,
                          lastName,
                          roomType,
                          checkin,
                          checkout,
                          email,
                          phone,
                          country,
                          adults,
                          kids,
                        } = this.form;
                        const roomTypeObj = this.roomTypes.find(e => e.id === Number(roomType));
                        httpClient.post('/new-reservation', {
                          firstName,
                          lastName,
                          checkin,
                          checkout,
                          email,
                          phone,
                          country,
                          lang: this.$language,
                          rooms: [{
                            roomType,
                            adults,
                            kids,
                            price: roomTypeObj.price || 0,
                          }],
                        }).then((resp) => {
                          this.$swal({
                            title: tr('modal_reservation_success_title'),
                            text: tr('modal_reservation_success_body'),
                            type: 'success',
                            input: null,
                          });
                          $("input, textarea").val('');
                          const $selectores = $('#booking-form').find('select');
                          $selectores.val('').selectpicker('refresh');
                          this.form = {
                            firstName: '',
                            lastName: '',
                            roomType: '',
                            checkin: '',
                            checkout: '',
                            email: '',
                            phone: '',
                            country: 0,
                            adults: '',
                            kids: '',
                          };
                          this.additionalPersons = 0;
                          this.availables = [];
                          this.$validator.clean();
                        }).catch((err) => {
                          console.log(err);
                          this.$swal(tr('modal_reservation_error_title'), tr('modal_reservation_error_body'), 'warning');
                        });
                      }, (dismiss) => {});
                  }
                } else {
                  // $('select').selectpicker('refresh');
                  this.$swal(tr('modal_reservation_warning_title'), tr('modal_reservation_warning_body'), 'warning');
                }
              });
            },
            getNightsTotal(nights, roomType) {
              return (nights * roomType.price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            },
            getAdditionalPersonsTotal(nights, roomType) {
              return (nights * (roomType.additionalPerson * this.additionalPersons)).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            },
        },
        computed: {
            availableRoomTypes() {
              if (this.availables) {
                return this.roomTypes.filter(e => this.availables.hasOwnProperty(e.id));
              }
              return [];
            },
            selectedRoomType() {
              if (this.form.roomType) {
                return this.roomTypes.find(e => e.id === Number(this.form.roomType));
              }
              return false;
            },
            nights() {
              const { checkin, checkout } = this.form;
              if (checkin && checkout) {
                return moment(checkout).diff(moment(checkin), 'days');
              }
              return 0;
            },
            subtotal() {
              if (this.form.roomType) {
                const { checkin, checkout, roomType, adults, kids } = this.form;
                const nights = moment(checkout).diff(moment(checkin), 'days');
                const roomTypeObj = this.roomTypes.find(e => e.id === Number(roomType));
                if (roomTypeObj) {
                  const totalPersons = Number(adults) + Number(kids);
                  let costPerNight = roomTypeObj.price;
                  console.log(totalPersons, roomTypeObj);
                  if (totalPersons > roomTypeObj.minCap && totalPersons <= roomTypeObj.maxCap) {
                    costPerNight += ((totalPersons - roomTypeObj.minCap) * roomTypeObj.additionalPerson);
                  }
                  return (nights * costPerNight).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                }
              }
              return 0;
            },
        },
    }
</script>


// WEBPACK FOOTER //
// book.vue?6c0145f9